import type { ILabelUsagePort, LabelUsageDto } from '@protocols/use-cases';
// The SDK is tagged `module:legacy` and is not in this module's dependency
// allowlist, so this import raises an `enforce-module-boundaries` warning. It is
// accepted deliberately: the cloud-function wrappers live there, and the rule is
// configured as a warning.
import { CloudFunctions } from '@telespot/sdk';

/**
 * Reads label usage over the `listLabelUsage` cloud function. The read cannot
 * run in the browser: it tests the label uuid as a query key path, which Parse
 * Server accepts only from the master key.
 */
export class HttpLabelUsagePort implements ILabelUsagePort {
  public list(labelUuid: string): Promise<LabelUsageDto[]> {
    // The cast is the wire boundary, made explicit: `Parse.Cloud.run` answers
    // `any`, and the cloud function returns the rows the same use case builds
    // server-side.
    return CloudFunctions.ListLabelUsage({ labelUuid }) as Promise<LabelUsageDto[]>;
  }
}
